import {
    OPEN_EULA_PROMPT,
    OPEN_ON_FETCH,
    ACCEPT_EULA,
    DECLINE_EULA,
    SET_BUTTON_TEXTS,
} from './constants'

const initialState = {
    userId: '',
    accepted: false,
    open: false,
    acceptText: '',
    declineText: '',
    newEula: false,
    openOnFetch: false,
}

export default function reducer(state = initialState, action) {
    switch (action.type) {
        case OPEN_EULA_PROMPT: {
            const { userId, newEula } = action.payload
            return {
                ...state,
                accepted: false,
                open: true,
                userId,
                newEula,
                openOnFetch: false,
            }
        }

        case OPEN_ON_FETCH: {
            return {
                ...state,
                openOnFetch: true,
            }
        }

        case ACCEPT_EULA: {
            return {
                ...state,
                accepted: true,
                open: false,
                newEula: false,
                openOnFetch: false,
            }
        }

        case DECLINE_EULA: {
            return {
                ...state,
                accepted: false,
                open: false,
                newEula: false,
                openOnFetch: false,
            }
        }

        case SET_BUTTON_TEXTS: {
            const { acceptText, declineText } = action.payload
            return {
                ...state,
                acceptText,
                declineText,
            }
        }

        // Do nothing
        default:
            return state
    }
}



// WEBPACK FOOTER //
// ./src/features/Eula/data/prompt/reducer.js